import React from 'react';
import _ from 'underscore';
import moment from 'moment';
import { Bar } from 'react-chartjs-2';

import {
  SeparateContainer,
  SeparateInnerContainer,
  ActiveTabBox,
  Heading,
  HeadingUnderLine,
  InfoIconContainer,
  InfoIcon,
} from '../styles';

export default React.memo(({ test, report, onInfoClick }) => {
  let result;
  if (test.adaptiveTest) {
    result = _.reduce(
      report.answers,
      function (memo, input) {
        var question = report.questions.find((question) => String(question._id) === String(input.question));
        if (!question) return memo;
        let i;
        let optionFound = input && report.options.find((option) => String(option._id) === String(input.option));
        if ((i = memo.labels.indexOf(question.category)) > -1) {
          memo.total[i] += 1;
          if (optionFound?.correct) memo.correct[i] += 1;
        } else {
          memo.labels.push(question.category);
          memo.total.push(1);
          memo.correct.push(optionFound?.correct ? 1 : 0);
        }
        return memo;
      },
      {
        labels: [],
        correct: [],
        total: [],
      }
    );
  } else {
    result = _.reduce(
      report.questions,
      function (memo, question) {
        if (question.createdAt && moment(question.createdAt) > moment(report.ticket.deadlineAt)) return memo;
        if (question.archived && question.updatedAt && moment(question.updatedAt) < moment(report.ticket.deadlineAt))
          return memo;
        if (!question.category) question.category = '';

        let input = report.answers.find((answer) => String(answer.question) === String(question._id));
        let i;
        let optionFound = input && report.options.find((option) => String(option._id) === String(input.option));
        if ((i = memo.labels.indexOf(question.category)) > -1) {
          memo.total[i] += 1;
          if (input && optionFound && optionFound.correct) memo.correct[i] += 1;
        } else {
          memo.labels.push(question.category);
          memo.total.push(1);
          memo.correct.push(input && optionFound && optionFound.correct ? 1 : 0);
        }
        return memo;
      },
      {
        labels: [],
        correct: [],
        total: [],
      }
    );
  }

  // The indexes of labels, correct, and total are related to each other.
  // We zip to preserve the link between indexes while sorting the data based on one array.
  let data = _.zip(result.labels, result.correct, result.total);

  // Sort data by length of labels in ascending order
  data.sort((a, b) => a[0].length - b[0].length);

  // Unzip the data after sorting it
  let sortedData = _.unzip(data);
  result.labels = sortedData[0];
  result.correct = sortedData[1];
  result.total = sortedData[2];

  // Split long labels into two rows
  // "Hello" --> ["Hello"]
  // "Very Long Sample String" --> ["Very Long", "Sample String"]
  let splitted = _.map(result.labels, (label) => split(label));

  function split(word) {
    var words = word.split(' ');
    var number = words.length;
    var row1 = '';
    var row2 = '';

    if (number <= 2) {
      return [word];
    }

    for (var i = 0; i < number; i += 1) {
      if (i < number / 2) {
        row1 += words[i] + ' ';
      } else {
        row2 += words[i] + ' ';
      }
    }

    row1 = row1.substring(0, row1.length - 1);
    row2 = row2.substring(0, row2.length - 1);
    return [row1, row2];
  }

  let difference = _.map(result.total, (total, index) => total - result.correct[index]);

  let tooltips = {
    callbacks: {
      label: function (context) {
        let index = context.datasetIndex;
        let selectedIndex = context.dataIndex;
        let correct = result.correct[selectedIndex];
        let total = result.total[selectedIndex];
        let label;
        if (index === 0) label = 'Correct: ' + correct + '/' + total;
        else label = 'Total: ' + total;
        return label;
      },
    },
  };

  const options = {
    plugins: {
      legend: {
        display: false,
      },
      tooltip: tooltips,
    },
    events: ['mousemove'],
    maintainAspectRatio: true,
    scales: {
      x: {
        stacked: true,
        title: {
          scaleStyle: 'bold',
          display: true,
          text: 'Category',
        },
        ticks: {
          autoSkip: false,
        },
        grid: {
          display: false,
        },
      },
      y: {
        stacked: true,
        title: {
          scaleStyle: 'bold',
          display: true,
          text: 'Number of questions',
        },
        grid: {
          display: false,
        },
        ticks: {
          stepSize: 1,
        },
        beginAtZero: true,
      },
    },
  };

  let barPercentage = difference.length <= 2 ? 0.3 : difference.length > 2 && difference.length <= 5 ? 0.5 : 0.9;
  const chartData = {
    labels: splitted,
    datasets: [
      {
        data: result.correct,
        backgroundColor: 'rgba(126, 198, 102, 1)',
        borderWidth: 1,
        barPercentage: barPercentage,
      },
      {
        data: difference,
        borderWidth: 1,
        barPercentage: barPercentage,
      },
    ],
    options: options,
  };

  return (
    <SeparateContainer extraBoxWithShadow={true}>
      <SeparateInnerContainer extraBoxWithShadow={true} maxHeightForPrint="460px">
        <ActiveTabBox noTopPadding={true}>
          <Heading>TEST CATEGORIES</Heading>
          <HeadingUnderLine />
          <Bar data={chartData} options={options} />
          <InfoIconContainer>
            <InfoIcon icon="fa fa-info-circle" marginLeft="50" onClick={() => onInfoClick()} />
          </InfoIconContainer>
        </ActiveTabBox>
      </SeparateInnerContainer>
    </SeparateContainer>
  );
});
